import { render } from "./QimenTurnaround.vue?vue&type=template&id=6d5c056d&scoped=true"
import script from "./QimenTurnaround.vue?vue&type=script&lang=js"
export * from "./QimenTurnaround.vue?vue&type=script&lang=js"

import "./QimenTurnaround.vue?vue&type=style&index=0&id=6d5c056d&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontendadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5c056d"]])

export default __exports__